var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-manage-tabs" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card", closable: "" },
          on: { "tab-remove": _vm.removeTab },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "菜品库", name: "dish", closable: false } },
            [
              _c("dishLibrary", {
                on: {
                  "open-edit": _vm.handleOpenEdit,
                  "open-add": _vm.handleOpenAdd,
                  "open-goodsMakeMethod": _vm.handleOpenGoodsMakeMethod,
                  "open-estimateInfo": _vm.handleOpenEstimateInfo,
                  "open-makeMethodEstimateInfo":
                    _vm.handleOpenMakeMethodEstimateInfo,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            {
              attrs: { label: "做法管理", name: "makeMethod", closable: false },
            },
            [
              _c("makeMethodMange", {
                on: {
                  "open-makeMethodEstimateInfo":
                    _vm.handleOpenMakeMethodEstimateInfo,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: "做法分类",
                name: "makeMethodType",
                closable: false,
              },
            },
            [_c("makeMethodTypeManage")],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.editTabs, function (item) {
            return _c(
              "el-tab-pane",
              { key: item.name, attrs: { label: item.title, name: item.name } },
              [
                _c("dishForm", {
                  attrs: { "goods-id": item.goodsId, type: item.type },
                  on: {
                    saved: function ($event) {
                      return _vm.closeEditTab(item.name, true)
                    },
                    cancel: function ($event) {
                      return _vm.closeEditTab(item.name, false)
                    },
                  },
                }),
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.goodsMakeMethodDisplay
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "商品做法",
                    closable: "",
                    name: "goodsMakeMethod",
                  },
                },
                [
                  _c("goodsMakeMethod", {
                    attrs: { goodsId: _vm.selectedGoodsId },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.estimateInfoDisplay
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "估清/限量",
                    closable: "",
                    name: "estimateInfo",
                  },
                },
                [
                  _c("estimateInfo", {
                    attrs: { goodsId: _vm.selectedGoodsId },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.makeMethodEstimateInfoDisplay
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "估清信息",
                    closable: "",
                    name: "makeMethodEstimateInfo",
                  },
                },
                [
                  _c("makeMethodEstimateInfo", {
                    attrs: { makeMethodId: _vm.selectedGoodsId },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }